import { Component } from 'react';
export default class BackArrowIcon extends Component {
    render() {
        return (
            <svg width="interit" height="interit" viewBox="0 0 16 16" fill="inherit" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.3332 5.33332H3.21984L6.9465 1.60666L5.99984 0.666656L0.666504 5.99999L5.99984 11.3333L6.93984 10.3933L3.21984 6.66666H11.3332V5.33332Z" fill="inherit"/>
            </svg>
        )
    }
};